import { render, staticRenderFns } from "./FormsPanel.vue?vue&type=template&id=4157bb3a&scoped=true&"
import script from "./FormsPanel.vue?vue&type=script&lang=js&"
export * from "./FormsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FormsPanel.vue?vue&type=style&index=0&id=4157bb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157bb3a",
  null
  
)

export default component.exports